import { AppUtils } from '../../utils/index';
/**
 * @deprecated use PhoneApi
 */
export class PhoneModel {
	private extension: string;
	private country: string;
	private suffix: string;
	private prefix: string;
	constructor(prefix?: string, suffix?: string, country?: string, extension?: string) {
		this.prefix = prefix;
		this.suffix = suffix;
		this.country = country;
		this.extension = extension;
	}
	/**
	 * Vorwahl.
	 *
	 * @return phone prefix matching regular expression pattern: ^[0-9]{1,8}$.
	 */
	get Prefix(): string {
		return this.prefix;
	}

	/**
	 * Vorwahl.
	 *
	 * @param value phone prefix matching regular expression pattern: ^[0-9]{1,8}$.
	 */
	set Prefix(value: string) {
		this.prefix = value;
	}

	/**
	 * Rufnummer.
	 *
	 * @return phone suffix matching regular expression pattern: ^[0-9]{1,8}$.
	 */
	get Suffix(): string {
		return this.suffix;
	}

	/**
	 * Rufnummer.
	 *
	 * @param value phone suffix matching regular expression pattern: ^[0-9]{1,8}$.
	 */
	set Suffix(value: string) {
		this.suffix = value;
	}

	/**
	 * Ländervorwahl.
	 *
	 * @return phone country.
	 */
	get Country(): string {
		return this.country;
	}

	/**
	 * Ländervorwahl.
	 *
	 * @param value phone country.
	 */
	set Country(value: string) {
		this.country = value;
	}

	/**
	 * Durchwahl.
	 *
	 * @return phone extension.
	 */
	get Extension(): string {
		return this.extension;
	}

	/**
	 * Durchwahl.
	 *
	 * @param value phone extension.
	 */
	set Extension(value: string) {
		this.extension = value;
	}

	public toRequestObject(): { [key: string]: any } {
		return {
			Prefix: this.prefix,
			Suffix: this.suffix,
			Country: this.country,
			Extension: this.extension
		};
	}

	/**
	 * Creates a new PhoneModel object and copies the values from the provided data object (or other calculator model) to the created PhoneModel.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): PhoneModel {
		return AppUtils.Helper.createFromMap(dataObject, PhoneModel);
	}
}